<template>
  <div class="card">
    <div
      v-if="!projectData.id"
      class="p-3"
    >
      <i
        v-if="!error"
        class="fa fa-spin fa-circle-o-notch"
      ></i>
      <div
        v-if="error"
      >
        {{ error }}
      </div>
    </div>
    <div
      v-if="projectData.id"
      class="card-body"
    >
      <header
        class="mb-3 w-100 d-flex align-items-center justify-content-between"
      >
        <h3 class="h5 mb-0">
          {{ projectData.title }}
        </h3>
        <div
          class="ml-auto mr-2"
          style="width:50px;"
        >
          <b-progress
            :max="100"
            height="1.5rem"
          >
            <b-progress-bar
              v-b-tooltip.hover
              :title="`${projectData.title} ${projectData.percent_complete}% complete`"
              :value="projectData.percent_complete"
              :variant="getProgressVariant(projectData.percent_complete)"
            ></b-progress-bar>
          </b-progress>
        </div>
        <div class="ml-1 ">
          <button
            class="btn btn-sm btn-white"
            :disabled="refreshing"
            @click="refreshProject()"
          >
            <span
              v-if="!refreshing"
            >
              <i class="fa fa-fw fa-sync"></i>
            </span>
            <span
              v-if="refreshing"
            >
              <i class="fa fa-fw fa-spin fa-sync"></i>
            </span>
          </button>
        </div>
      </header>
      <section
        v-for="list in lists"
        :key="`tasks_${list.id}`"
        class="card mb-3"
      >
        <div class="card-body">
          <header class="d-flex w-100 align-items-center">
            <div>
              <button
                class="btn btn-sm btn-white mr-3"
                @click.prevent="list._expanded = !list._expanded"
              >
                <i
                  v-if="list._expanded"
                  class="fa fa-fw fa-caret-up"
                ></i>
                <i
                  v-if="!list._expanded"
                  class="fa fa-fw fa-caret-down"
                ></i>
              </button>
            </div>
            <h4
              class="h6 mb-0"
            >
              {{ list.title || 'Untitled List' }}
            </h4>
            <div
              class="ml-auto"
              style="width:50px;"
            >
              <b-progress
                :max="100"
                height="1.5rem"
              >
                <b-progress-bar
                  v-b-tooltip.hover
                  :title="`${list.title} ${list.percent_complete}% complete`"
                  :value="list.percent_complete"
                  :variant="getProgressVariant(list.percent_complete)"
                ></b-progress-bar>
              </b-progress>
            </div>
          </header>
          <div
            v-if="list._expanded"
            class="mt-3"
          >
            <hr>
            <task-list
              :ref="`tasks_${list.id}`"
              :list="list"
              :editable="editable"
              @updated="updateProjectProgress()"
            ></task-list>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import TaskList from '@/components/TaskList'
import { getProject, getProjectByConnection } from '@/api'
import sum from 'lodash/sum'
import map from 'lodash/map'

export default {
  components: {
    TaskList
  },
  props: {
    project: {
      required: false,
      type: Object,
      default () {
        return null
      },
    },
    connection: {
      required: false,
      type: String,
      default () {
        return null
      },
    },
    projectId: {
      required: false,
      type: [String, Number],
      default () {
        return null
      },
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      projectData: {
        id: null,
        title: null,
        percent_complete: 0,
      },
      lists: [],
      refreshing: false,
      error: null
    }
  },
  async mounted () {
    try {
      if (!this.project) {
        if (this.connection && this.projectId) {
          let response = await getProjectByConnection(this.connection, this.projectId)
          this.projectData = response.data.data
          this.lists = this.projectData.lists
        } else if (this.projectId) {
          let response = await getProject(this.projectId)
          this.projectData = response.data.data
          this.lists = this.projectData.lists
        }
      } else if (this.project) {
        this.projectData = this.project
      }
    } catch (e) {
      this.error = 'Oops! Something went wrong while loading this project. Please try again.'
    }
  },
  methods: {
    async refreshProject () {
      this.refreshing = true
      let response = await getProject(this.projectData.id, true)
      this.projectData = response.data.data
      this.lists = this.projectData.lists
      this.refreshing = false
    },
    getProgressVariant (percentComplete) {
      if (percentComplete < 80) {
        return 'danger'
      } else if (percentComplete < 100) {
        return 'warning'
      } else {
        return 'success'
      }
    },
    updateProjectProgress () {
      if (!this.lists.length) {
        this.projectData.percent_complete = 0
      } else {
        this.projectData.percent_complete = Math.round(sum(map(this.lists, (list) => list.percent_complete)) / this.lists.length)
      }
    }
  },
}
</script>
